import { render, staticRenderFns } from "./sign-in-processing.vue?vue&type=template&id=2815d789&scoped=true"
import script from "./sign-in-processing.vue?vue&type=script&lang=js"
export * from "./sign-in-processing.vue?vue&type=script&lang=js"
import style0 from "./sign-in-processing.vue?vue&type=style&index=0&id=2815d789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815d789",
  null
  
)

export default component.exports